module.exports = __webpack_public_path__ + "assets/2983bfe2d854a2f15859ee02b86fd5c5.png";